import { Reveal } from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";

const cases = [
  {
    title: "Fiya Red — “1998” EP",
    tags: ["EP Cover", "Vinyl"],
    result: "Debut EP — track snippets playing above",
    img: "/assets/homage-vinyl-1998.png",
  },
];

export const Work = () => (
  <section id="work" data-testid="work-section" className="py-28 md:py-44 bg-[#B5D5C5]/35">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <Reveal className="mb-16 md:mb-24 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-[#2D1A13]/50 mb-6">Selected Work</p>
          <h2 className="font-serif-display font-bold tracking-tighter text-4xl md:text-6xl leading-tight">
            Fresh from <span className="italic text-[#FF8E9E]">the freezer.</span>
          </h2>
        </div>
        <p className="max-w-sm text-sm font-light leading-relaxed text-[#2D1A13]/60">
          A taste of recent launches. Full case studies served on request.
        </p>
      </Reveal>

      <div className="flex justify-center">
        {cases.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.12} className="w-full max-w-4xl">
            <div data-testid={`case-card-${i}`} className="group cursor-pointer">
              <div className="overflow-hidden rounded-[28px] aspect-[4/3] relative">
                <img
                  src={c.img}
                  alt={c.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]"
                />
                <span className="absolute top-5 right-5 w-12 h-12 rounded-full bg-[#FDFBF7] flex items-center justify-center opacity-0 group-hover:opacity-100 group-hover:rotate-45 transition-all duration-500">
                  <ArrowUpRight size={20} strokeWidth={1.8} />
                </span>
              </div>
              <div className="mt-7">
                <div className="flex gap-3 mb-4">
                  {c.tags.map((t) => (
                    <span key={t} className="rounded-full border border-[#2D1A13]/25 px-4 py-1.5 text-[10px] font-semibold uppercase tracking-[0.18em] text-[#2D1A13]/70">
                      {t}
                    </span>
                  ))}
                </div>
                <h3 className="font-serif-display font-bold text-2xl md:text-3xl tracking-tight mb-2">{c.title}</h3>
                <p className="text-sm font-light text-[#2D1A13]/60">{c.result}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
